

                  // 

document.addEventListener('DOMContentLoaded', function () {
  const container = document.querySelector('.filters-by-model-tags');
  const toggleBtn = document.getElementById('filters-by-model-tags-toggle');

  if (!container || !toggleBtn) return;

  const cards = container.querySelectorAll('.card');
  let expanded = false;

  function getVisibleCount() {
    const width = window.innerWidth;

    if (width < 475) {
      return 4;
    } else if (width < 768) {
      return 8;
    } else {
      return 6;
    }
  }

  function updateView() {
    const visibleCount = getVisibleCount();

    cards.forEach((card, index) => {
      if (expanded || index < visibleCount) {
        card.classList.add('is-visible');
      } else {
        card.classList.remove('is-visible');
      }
    });

    toggleBtn.textContent = expanded ? 'Weniger anzeigen' : 'Mehr anzeigen';

    // Hide toggle if not needed
    toggleBtn.style.display = cards.length > visibleCount ? 'block' : 'none';
  }

  toggleBtn.addEventListener('click', function () {
    expanded = !expanded;
    updateView();
  });

  // Recalculate on resize
  window.addEventListener('resize', function () {
    if (!expanded) {
      updateView();
    }
  });

  updateView();
});



// COLOR FAMILY FILTER SCRIPT
// 
if (document.querySelector('.main_color_family')) {
  

        document.addEventListener('DOMContentLoaded', () => {
          const colorButtons = document.querySelectorAll('.main_color_family');
          const variantItems = document.querySelectorAll(
            '.product-variant__item[data-parent-color]'
          );

          //  INITIAL STATE (PRESELECTED)
          const selectedInput = document.querySelector(
            '.product-variant__input:checked'
          );

          let activeColor = null;

          if (selectedInput) {
            const selectedItem = selectedInput.closest('.product-variant__item');
            activeColor = selectedItem?.dataset.parentColor || null;
          }

          variantItems.forEach(item => {
            item.style.display =
              activeColor && item.dataset.parentColor === activeColor
                ? 'inline-block'
                : 'none';
          });

          colorButtons.forEach(btn => {
            btn.classList.toggle(
              'is-active',
              btn.dataset.parentColor === activeColor
            );
          });

          // CLICK HANDLER
          colorButtons.forEach(button => {
            button.addEventListener('click', e => {
              e.preventDefault();

              const selectedColor = button.dataset.parentColor;
              let firstVisibleInput = null;

              colorButtons.forEach(btn => {
                btn.classList.remove('is-active');
              });
              button.classList.add('is-active');

              // Only show items that match the selected color
              // If no selectedColor or empty string, hide all items
              if (!selectedColor || selectedColor.trim() === '') {
                variantItems.forEach(item => {
                  item.style.display = 'none';
                });
                return;
              }

              variantItems.forEach(item => {
                const itemParentColor = item.dataset.parentColor;
                
                // Strict comparison - both must exist, be non-empty, and match exactly
                if (itemParentColor && itemParentColor.trim() !== '' && itemParentColor === selectedColor) {
                  item.style.display = 'inline-block';

                  if (!firstVisibleInput) {
                    firstVisibleInput = item.querySelector('input[type="radio"]');
                  }
                } else {
                  item.style.display = 'none';
                }
              });

              if (firstVisibleInput) {
                firstVisibleInput.checked = true;
                firstVisibleInput.dispatchEvent(
                  new Event('change', { bubbles: true })
                );
              }
            });
          });

          // Function to reset to first color and first variant
          window.resetToFirstColor = function() {
            const firstColorButton = colorButtons[0];
            if (firstColorButton) {
              firstColorButton.click();
            }
          };
        });
        }
        // SEARCH SCRIPT FOR COLOR VARIANTS
        document.addEventListener("DOMContentLoaded", function () {
          const searchInput = document.getElementById("search-with-variant-labels");
          const variantItems = document.querySelectorAll(".product-variant__item--color");
          const colorFamilyContainer = document.querySelector(".main_colors_family-container");

          if (!searchInput || !variantItems.length) return;

          searchInput.addEventListener("keyup", function () {
            const query = this.value.trim().toLowerCase();

            if (colorFamilyContainer) {
              colorFamilyContainer.style.display = query ? "none" : "";
            }

            // If search is cleared, reset to first color
            if (!query) {
              if (typeof window.resetToFirstColor === 'function') {
                window.resetToFirstColor();
              }
            }

            variantItems.forEach(item => {
              const input = item.querySelector("input");
              const hiddenLabel = item.querySelector(".visually-hidden");
              const fullLabel = item.querySelector(".product-variant__label");

              const valueText = input?.value?.toLowerCase() || "";
              const hiddenText = hiddenLabel?.textContent?.toLowerCase() || "";
              const labelText = fullLabel?.textContent?.toLowerCase() || "";

              const match =
                valueText.includes(query) ||
                hiddenText.includes(query) ||
                labelText.includes(query);

              item.style.display = match || !query ? "" : "none";
            });
          });
        });

        // SEARCH SCRIPT FOR RADIO VARIANTS
        document.addEventListener("DOMContentLoaded", function () {
          const searchInput = document.getElementById("search-with-variant-labels");
          const variantItems = document.querySelectorAll(".product-variant__item--radio");
          const colorFamilyContainer = document.querySelector(".main_colors_family-container");

          if (!searchInput || !variantItems.length) return;

          searchInput.addEventListener("keyup", function () {
            const query = this.value.trim().toLowerCase();

            if (colorFamilyContainer) {
              colorFamilyContainer.style.display = query ? "none" : "";
            }

            // If search is cleared, reset to first color
            if (!query) {
              if (typeof window.resetToFirstColor === 'function') {
                window.resetToFirstColor();
              }
            }

            variantItems.forEach(item => {
              const input = item.querySelector("input");
              const label = item.querySelector(".product-variant__label");

              const valueText = input?.value?.toLowerCase() || "";

              const valueParts = valueText.split(",").map(v => v.trim());

              const labelText = label?.textContent?.trim().toLowerCase() || "";

              const searchableText = [
                valueText,
                ...valueParts,
                labelText
              ].join(" ");

              const match = searchableText.includes(query);

              item.style.display = match || !query ? "" : "none";
            });
          });
        });



        // page loader




document.addEventListener('DOMContentLoaded', function() {
    const preloader = document.getElementById('page-preloader');
    if (!preloader) return;
    preloader.classList.add('loader-hidden');
    setTimeout(() => {
      preloader.style.display = 'none';
    }, 200);
  });




// graduated price table unit price

(function () {

  // -------------------------
  // Helper: parse German price
  // -------------------------
  function parsePrice(text) {
    if (!text) return null;
    text = text.replace(/\./g, "");
    text = text.replace(",", ".");
    text = text.replace(/[^\d.]/g, "");
    const num = parseFloat(text);
    return isNaN(num) ? null : num;
  }

  function processTable() {
    const table = document.querySelector(".hulkapps-table");
    const titleEl = document.querySelector(".product__title");

    if (!table || !titleEl) return;

    const title = titleEl.innerText.toLowerCase();

    // -------------------------
    // Default setup
    // -------------------------
    let mode = "thread";
    let meters = 1000;
    let pieces = 1;
    let customDivisor = null;
    let unitLabel = "";

    // -------------------------
    // 1️⃣ Rundkopfstecknadel (priority)
    // -------------------------
    if (title.includes("rundkopfstecknadel")) {
      mode = "custom";
      customDivisor = 80;
      unitLabel = "€ / Stück";

    // -------------------------
    // 2️⃣ Stoffklammern
    // -------------------------
    } else if (title.includes("stoffklammern")) {
      mode = "custom";
      customDivisor = 12;
      unitLabel = "€ / Stück";

    // -------------------------
    // 3️⃣ Spulen
    // -------------------------
    } else if (title.includes("spulen")) {
      mode = "custom";
      customDivisor = 10;
      unitLabel = "€ / Stück";

    // -------------------------
    // 4️⃣ Stickvlies
    // -------------------------
    } else if (title.includes("stickvlies")) {
      mode = "custom";
      customDivisor = 1;
      unitLabel = "€ / m²";

    // -------------------------
    // 5️⃣ Needles
    // -------------------------
    } else if (title.includes("nadel")) {
  mode = "needle";

  const needleMatch = title.match(/\((\d+)\s+[^\)]*nadeln?\)/i)
                     || title.match(/(\d+)\s+[^\d]*nadeln?/i);

  pieces = needleMatch ? parseInt(needleMatch[1]) : 1;

    // -------------------------
    // 6️⃣ Threads (meters)
    // -------------------------
    } else {
      const meterMatch = title.match(/([\d\.]+)\s*m/i);
      if (meterMatch) {
        meters = parseInt(meterMatch[1].replace(/\./g, ""));
      }
    }

    // -------------------------
    // Add header if not exists
    // -------------------------
    if (!table.querySelector(".grundpreis-head")) {
      const headRow = table.querySelector("thead tr");
      if (headRow) {
        const th = document.createElement("th");
        th.innerText = "Grundpreis";
        th.className = "grundpreis-head";
        headRow.appendChild(th);
      }
    }

    // -------------------------
    // Process rows
    // -------------------------
    table.querySelectorAll("tbody tr").forEach(row => {

      if (row.querySelector(".grundpreis-cell")) return;

      const moneyEl = row.querySelector(".money");
      if (!moneyEl) return;

      const price = parsePrice(moneyEl.innerText);
      if (price === null) return;

      const td = document.createElement("td");
      td.className = "grundpreis-cell";

      let unitPrice = 0;

      if (mode === "thread") {
        unitPrice = (price / meters) * 100;
        td.innerText = unitPrice.toFixed(2).replace(".", ",") + " € / 100 m";

      } else if (mode === "needle") {
        unitPrice = price / pieces;
        td.innerText = unitPrice.toFixed(2).replace(".", ",") + " € / Nadel";

      } else if (mode === "custom") {
        unitPrice = price / customDivisor;
        td.innerText = unitPrice.toFixed(2).replace(".", ",") + " " + unitLabel;
      }

      row.appendChild(td);
    });

    // -------------------------
    // Hide extended price block
    // -------------------------
    const box = document.querySelector('[data-update-block="price-extended-main"]');
    if (box) box.style.display = "none";
  }

  window.addEventListener("load", processTable);

  const observer = new MutationObserver(() => processTable());
  observer.observe(document.body, { childList: true, subtree: true });

})();

// 

// Select the image

setTimeout(() => {
  


  const img = document.querySelector('.product-item-thumbnail.fg-gift-image');

  if (img) {
    // Get alt text
    const altText = img.alt;

    // Create new element
    const caption = document.createElement('div');
    caption.className = 'custom-alt-text';
    caption.textContent = altText;

    // Insert after image
    img.insertAdjacentElement('afterend', caption);
  }
}, 2000);


if (document.getElementById('size-chart-modal')) {
  basicLightbox.create(document.getElementById('size-chart-modal'), {
    trigger: document.querySelector('.js-toggle-size-chart-modal'),
  });
}


// usercentric popup manual trigger
document.getElementById("open-cookie-settings").addEventListener("click", function(e) {
    e.preventDefault();
    if (window.UC_UI) {
        window.UC_UI.showSecondLayer();
    }
}); 

// script to hide the usercentric cookiee banner button as it is coming on shadow root 
function hidePrivacyButton() {
  const cmp = document.querySelector('#usercentrics-cmp-ui');
  if (!cmp || !cmp.shadowRoot) return;

  const shadow = cmp.shadowRoot;

  const hide = () => {
    const btn = shadow.querySelector('#uc-main-dialog.privacyButton');
    if (btn) {
      btn.style.display = 'none';
    }
  };

  // run once
  hide();

  // watch for rerenders
  const observer = new MutationObserver(hide);
  observer.observe(shadow, {
    childList: true,
    subtree: true
  });
}

const waitForCMP = setInterval(() => {
  const cmp = document.querySelector('#usercentrics-cmp-ui');

  if (cmp?.shadowRoot) {
    clearInterval(waitForCMP);
    hidePrivacyButton();
  }
}, 200);



// percentage amount saved in subscriptions
(function () {

  function initBadges() {
    const wrappers = document.querySelectorAll('.appstle_subscription_amount_wrapper');

    if (!wrappers.length) {
      setTimeout(initBadges, 500);
      return;
    }

    wrappers.forEach(wrapper => {

      const priceEl = wrapper.querySelector('.appstle_subscription_amount');
      const compareEl = wrapper.querySelector('.appstle_subscription_compare_amount');

      // ✅ correct parent block
      const parentOption = wrapper.closest('.appstle_subscription_wrapper_option');

      if (!priceEl || !compareEl || !parentOption) return;

      const labelEl = parentOption.querySelector('.appstle_radio_label');

      if (!labelEl) return;

      // جلوگیری duplicate
      if (labelEl.querySelector('.discount-badge')) return;

      // prices
      const price = parseFloat(priceEl.innerText.replace(',', '.').replace(/[^\d.]/g, ''));
      const compare = parseFloat(compareEl.innerText.replace(',', '.').replace(/[^\d.]/g, ''));

      if (!price || !compare || compare <= price) return;

      const percent = Math.round(((compare - price) / compare) * 100);

      // create badge
      const badge = document.createElement('div');
      badge.className = 'discount-badge';
      badge.innerText = `${percent}% sparen`; // German version

      // ✅ append under label
      labelEl.appendChild(badge);
    });
  }

  // delay start (Appstle loads late)
  setTimeout(initBadges, 1000);

})();

